import { ShopDisplayType } from "@/api/types";
import {
  CartItem,
  CartItemProps,
} from "molecules/containers/cart/cart-item/CartItem";

export interface CartItemListProps {
  cartItems: CartItemProps[];
}

export const CartItemList = ({ cartItems }: CartItemListProps) => {
  if (!cartItems.length) return null;

  const getFulfillmentType = (type: number) => {
    switch (type) {
      case ShopDisplayType.Product:
        return "Pickup";
      case ShopDisplayType.ProductFromExternalSource:
        return "Delivery";
      default:
        return null;
    }
  };

  return (
    <div className="bg-one">
      <div className="divide-y divide-solid divide-light-grey">
        {cartItems.map((cartItem) => (
          <CartItem
            key={cartItem.id}
            fulfillmentType={getFulfillmentType(cartItem.type)} // TODO: Replace with actual fulfillment type once shipping is implemented
            {...cartItem}
          />
        ))}
      </div>
      <hr className="bg-light-grey" />
    </div>
  );
};
